import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Client-side gate for /creator/dashboard. API still enforces requireCreator.
 */
function CreatorRoute({ children }) {
  const navigate = useNavigate();
  const { isAuthenticated, user, loading } = useAuth();

  useEffect(() => {
    if (loading) {
      return;
    }
    if (!isAuthenticated) {
      navigate('/signin', { replace: true });
      return;
    }
    if (user?.role !== 'creator' || user?.creatorId == null) {
      navigate('/', { replace: true });
    }
  }, [loading, isAuthenticated, user?.role, user?.creatorId, navigate]);

  if (loading) {
    return null;
  }

  if (!isAuthenticated || user?.role !== 'creator' || user?.creatorId == null) {
    return null;
  }

  return children;
}

export default CreatorRoute;
